var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:['grid-list', ("grid-list__" + (_vm.children.length)), _vm.css]},_vm._l((_vm.children),function(item){return _c(item.type,_vm._b({key:item.title,tag:"component"},'component',item,false))}),1)}
var staticRenderFns = []

export { render, staticRenderFns }